import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTolls, clearTolls } from '../../../../actions/index';
import Select from './Select';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { optionsPropTypes } from './SelectPropTypes';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';

const TollSelect = ({
  options,
  loading,
  noOptionsMessage,
  input,
  meta,
  isDisabled,
  isClearable,
  isMulti,
  onlyExtraordinary,
  dispatchGetTolls,
  dispatchClearTolls,
}) => {
  useEffect(() => {
    dispatchGetTolls({
      ...DEFAULT_QUERY_GET_ALL,
      ...(onlyExtraordinary ? { query: ['isExtraordinary:true'] } : {}),
    });

    return () => {
      dispatchClearTolls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const props = {
    options,
    isLoading: loading,
    noOptionsMessage,
    input,
    meta,
    isDisabled,
    isClearable,
    isMulti,
  };

  return <Select {...props} />;
};

const mapStateToProps = ({ RouteUnit }) => ({
  options: RouteUnit.Toll.getIn(['all', 'content', 'content']).map(
    ({ id, location: { name } }) => ({
      value: id,
      label: name,
    }),
  ),
  loading: RouteUnit.Toll.getIn(['all', 'loading']),
});

TollSelect.propTypes = {
  options: optionsPropTypes,
  loading: PropTypes.bool.isRequired,
  noOptionsMessage: PropTypes.func,
  dispatchGetTolls: PropTypes.func.isRequired,
  dispatchClearTolls: PropTypes.func.isRequired,
  input: inputPropTypes,
  meta: metaPropTypes,
  isDisabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  isMulti: PropTypes.bool,
  onlyExtraordinary: PropTypes.bool,
};

TollSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  noOptionsMessage: undefined,
  isDisabled: false,
  isClearable: false,
  isMulti: false,
  options: [],
  onlyExtraordinary: false,
};
const mapDispatchToProps = {
  dispatchGetTolls: getTolls,
  dispatchClearTolls: clearTolls,
};

export default connect(mapStateToProps, mapDispatchToProps)(TollSelect);
